import services from "@/http";
import * as types from "./mutation-types";
import * as storage from "../storage";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetMoedas", data.data);
  dispatch("ActionSetPagination", data.meta);
  return data.data;
};

export const ActionFind = async (store, search) => {
  var moedas = {
    data: [],
    meta: {},
  };

  await services.moedas.get_all(search).then((res) => {
    moedas = res.data;
  });
  return moedas;
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.moedas.show({ id: id }).then((res) => {
    dispatch("ActionSetMoeda", res.data.moeda);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  await services.moedas.store(payload).then((res) => {
    commit(types.SET_MOEDA, res.data.moeda);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.moedas.update({ id: payload.id }, payload).then((res) => {
    commit(types.SET_MOEDA, res.data.moeda);
  });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.moedas.delete({ id: id }).then(() => {
    commit(types.SET_MOEDA, null);
  });
};

export const ActionSetMoedas = ({ commit }, payload) => {
  commit(types.SET_MOEDAS, payload);
};

export const ActionSetMoeda = ({ commit }, payload) => {
  commit(types.SET_MOEDA, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewMoeda = ({ commit }) => {
  let moeda = {
    nome: "",
    sigla: "",
  };
  commit(types.SET_MOEDA, moeda);
};

export const ActionToSelect = async ({ dispatch }, id) => {
  let response = storage.getMoedasToSelect();
  if (!response || !response.length) {
    response = [];
    await services.moedas.to_select().then((res) => {
      response = res.data;
    });
    storage.setMoedasToSelect(response);
  }
  return response;
};
